export default __webpack_public_path__ + "static/media/formNavArrow.a46e9b47.svg";